import React, { useState, useEffect } from 'react';
import EmpresaForm from './components/EmpresaForm';
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import Reload from '../../components/reload/reload';
import CsvUploadCard from '../../components/CsvUploadCard/CsvUploadCard';
import useUnits from '../../hooks/useUnits';

const Empresa = () => {
  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvError, setCsvError] = useState('');

  const units = useUnits();

/*   useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timeout);
  }, []); */

  const handleCsvUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setCsvError('O arquivo excede o tamanho máximo de 5MB.');
        setCsvFile(null);
      } else if (!file.name.endsWith('.csv')) {
        setCsvError('Formato de arquivo inválido. Apenas arquivos .csv são aceitos.');
        setCsvFile(null);
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const content = e.target.result;
          const lines = content.split('\n').map(line => line.replace(/\r$/, ''));
          
          if (lines.length > 0) {
            const headers = lines[0].toLowerCase().split(',');           
            if (!headers.includes('serial') || !headers.includes('id')) {
              setCsvError('Erro: O arquivo CSV deve conter as colunas "serial" e "id"');
              setCsvFile(null);
              return;
            }
            setCsvError('');
            setCsvFile(file);
          } else {
            setCsvError('Arquivo vazio ou inválido');
            setCsvFile(null);
          }
        };
        reader.readAsText(file);
      }
    }
  };

  return (
    <Page title={"Dados da Empresa"}>
      <Headers page={"Dados da Empresa"} />
      {loading && <Reload />}

      <CsvUploadCard
        onFileUpload={handleCsvUpload}
        file={csvFile}
        error={csvError}
        title="Importar Dados CSV"
        description="Carregue um arquivo CSV"
        requiredColumns={['serial', 'id']}
        maxFileSize={5}
        companies={units} 
      />
      
      <EmpresaForm companies={units} />

    </Page>
  )
}
export default Empresa;
